<template>
  <ResourceView :entityId="$route.params.typeId" entityClass="MachineType">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewMachineTypeResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style scoped></style>